<link *ngIf="customCss" rel="stylesheet" [href]="customCss"/>
<div *ngIf="!environment.production"
     style="background-color: #912727; text-align: center; color: white;">TEST BUILD</div>
<router-outlet></router-outlet>
<script *ngIf="customJs" [src]="customJs" async defer></script>
